/**
 * Filename utility functions
 * Provides consistent filename generation across the application
 */

import type { Invoice } from '@shared/schemas/invoice.schema';

/**
 * Generates a consistent filename for invoice/receipt downloads
 * Priority: invoiceNumber > invoiceDate > 'invoice'/'receipt'
 * Sanitizes the filename by replacing spaces with hyphens
 */
export function generateInvoiceFilename(invoice: Invoice): string {
  // Try invoice number first
  if (invoice.invoiceNumber) {
    return invoice.invoiceNumber.replace(/\s+/g, '-');
  }

  // Fallback to invoice date
  if (invoice.invoiceDate) {
    const date = typeof invoice.invoiceDate === 'string'
      ? new Date(invoice.invoiceDate)
      : invoice.invoiceDate;
    return date.toISOString().split('T')[0];
  }

  // Final fallback based on document type
  const docType = invoice.documentType === 'receipt' ? 'receipt' : 'invoice';
  return `${docType}-${Date.now()}`;
}
